import { useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";
import { Droplets, Loader2, Trash2 } from "lucide-react";

const fmtKm = (n) => (n == null ? "—" : `${Number(n).toLocaleString("pt-BR")} km`);
const fmtD = (s) => (s ? new Date(`${s}T12:00:00`).toLocaleDateString("pt-BR") : "—");

export function OilSummary({ oil }) {
  if (!oil) return null;
  return (
    <div data-testid="oil-summary" className="text-sm text-zinc-300">
      Última troca: {fmtD(oil.date)} aos {fmtKm(oil.km)}{oil.oil ? ` (${oil.oil})` : ""} · <b className="text-zinc-100">Próxima: {fmtKm(oil.next_km)} ou {fmtD(oil.next_date)}</b>
      <span className="text-zinc-500"> — o que vier primeiro</span>
    </div>
  );
}

export function OilChangeCard({ order, shop, onSaved }) {
  const cfg = shop?.oil || {};
  const oc = order.oil_change;
  const [f, setF] = useState({ km: oc?.km ?? order.vehicle?.current_km ?? "", interval_km: oc?.interval_km ?? cfg.interval_km ?? 10000, interval_months: oc?.interval_months ?? cfg.interval_months ?? 6, oil: oc?.oil || "" });
  const [open, setOpen] = useState(false);
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setF((p) => ({ ...p, [k]: e.target.value }));
  const save = async () => {
    setBusy(true);
    try { await api.put(`/orders/${order.id}/oil-change`, { km: Number(f.km), interval_km: Number(f.interval_km), interval_months: Number(f.interval_months), oil: f.oil }); toast.success("Troca de óleo registrada"); setOpen(false); onSaved?.(); }
    catch (e) { toast.error(formatApiError(e)); } finally { setBusy(false); }
  };
  const remove = async () => {
    try { await api.delete(`/orders/${order.id}/oil-change`); toast.success("Removido"); onSaved?.(); } catch (e) { toast.error(formatApiError(e)); }
  };
  return (
    <div data-testid="oil-change-card" className="space-y-2">
      <div className="flex items-center justify-between gap-2">
        <div className="flex items-center gap-2 text-xs font-mono-caps text-zinc-500 uppercase tracking-widest"><Droplets className="h-4 w-4" /> Troca de óleo</div>
        <div className="flex gap-1">
          <Button data-testid="oil-open-btn" size="sm" variant="outline" onClick={() => setOpen((o) => !o)} className="bg-zinc-900 border-zinc-800">{oc ? "Editar" : "Registrar troca de óleo"}</Button>
          {oc && <Button data-testid="oil-remove-btn" size="sm" variant="ghost" onClick={remove} className="text-zinc-500"><Trash2 className="h-4 w-4" /></Button>}
        </div>
      </div>
      <OilSummary oil={oc} />
      {open && (
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-2 items-end">
          <label className="text-[11px] text-zinc-400">KM atual<Input data-testid="oil-km" type="number" value={f.km} onChange={set("km")} className="mt-1 bg-zinc-900 border-zinc-800" /></label>
          <label className="text-[11px] text-zinc-400">Intervalo (km)<Input data-testid="oil-interval-km" type="number" value={f.interval_km} onChange={set("interval_km")} className="mt-1 bg-zinc-900 border-zinc-800" /></label>
          <label className="text-[11px] text-zinc-400">Ou meses<Input data-testid="oil-interval-months" type="number" value={f.interval_months} onChange={set("interval_months")} className="mt-1 bg-zinc-900 border-zinc-800" /></label>
          <label className="text-[11px] text-zinc-400">Óleo usado<Input data-testid="oil-type" value={f.oil} onChange={set("oil")} placeholder="5W30 sintético" className="mt-1 bg-zinc-900 border-zinc-800" /></label>
          <Button data-testid="oil-save-btn" onClick={save} disabled={busy || !f.km} className="col-span-2 sm:col-span-4 bg-green-brand text-white font-bold">{busy ? <Loader2 className="h-4 w-4 animate-spin" /> : "Salvar e calcular próxima troca"}</Button>
        </div>
      )}
    </div>
  );
}
